'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);
import 'slick-carousel';
import SimpleBar from 'simplebar';

/**
 * module
 */
import { disabled } from './module/_disabled';
import { fitimg } from './module/_fitimg';
import { anchor } from './module/_anchor';
import { nav } from './module/_nav';
import { hover } from './module/_hover';
import { modal } from './module/_modal';
import { tab } from './module/_tab';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        const getParam = (name, url) => {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');

            let results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        };

        if (getParam('cp') === 'episode') {
            document.getElementById('js-tab-02').click();
        }

        setTimeout(function() {
            $('body').addClass('is-loaded');
            $('.layout-content__inner').addClass('is-start');
        }, 500);
    };

    /**
     * init
     */
    const init = () => {
        modal.init();
        disabled.init();
        fitimg.init();
        anchor.init();
        nav.init();
        hover.init();
        tab.init();

        $('.js-carousel-hero').slick({
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 1000,
            dots: true
        });

        // new SimpleBar($('.js-scrBar')[0], {
        //     autoHide: false
        // });
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});
